export default {"src":"/_next/static/media/LIT.12db2b98.svg","height":18,"width":18};